import InboomaBaseFilterableCollection from "./InboomaBaseFilterableCollection";

import User from "../models/User";

export default InboomaBaseFilterableCollection.extend({
  collectionName: "users",
  model: User,
  url: "/users",

  _pagination: {
    current_page: 0,
    has_next_page: true,
    has_prev_page: false,
    count: 0,
    limit: 100,
    sort: "created",
    sortDirection: "desc",
  },

  _filterParams: {},

  filterById(user_id) {
    return this.addFilter("id", user_id);
  },

  filterByIsEmployee(isEmployee, skipPagination = false) {
    isEmployee
      ? (this._filterParams.find = "IsEmployee")
      : (this._filterParams.find = "!IsEmployee");

    this._pagination.current_page = 0;
    if (!skipPagination) delete this._skipPagination;
    else this._skipPagination = true;

    this.fetchFirstPage(
      function () {},
      false,
      this._pagination.sort,
      this._pagination.sortDirection,
    );
  },
});
